import request from './request';

const getCurrentIssueAsync = lotteryId => request.get('lotto/GetCurrentIssue', { lotteryId });

const getJiGuangTjStatisticsAsync = (lotteryId, begin, end, limit, skip) => request.get('JiGuangTj/GetDataByRange', { lotteryId, begin, end, limit, skip });

const getStatisticsAsync = (lotteryId, begin, end, limit, skip) => request.get('lotto/GetDataByRange', { lotteryId, begin, end, limit, skip });

export default { getCurrentIssueAsync, getJiGuangTjStatisticsAsync, getStatisticsAsync };